import {
  $dealerships,
  $loading,
  $replaceForms,
  $state,
  setDealerships,
  setLoading,
  setReplaceForms,
  setState
} from './units'

$state.on(setState, (_, state) => state)

$dealerships.on(setDealerships, (_, values) => values)

$loading.on(setLoading, (_, values) => values)

$replaceForms.on(setReplaceForms, (_, value) => value)
